/*global swal angular*/

import './style.less';
import { findIndex, get, orderBy } from 'lodash';

export default function(
  $log,
  $transitions,
  $window,
  $q,
  $location,
  $state,
  $scope,
  $stateParams,
  Swal,
  store,
  ApiClass,
  AuthClass,
  HelperClass,
  ProfileClass,
  UserClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const {
    profile: { company_id },
    company: { preferences }
  } = ProfileClass.profileComplete;

  const baseUrl = $location.$$absUrl.split('/')[0];

  let usersDict = {};
  let users = [];
  let uninvitedUsers = [];

  vm.createUsersFromCSV = data => {
    data.filter(({ email }) => HelperClass.validateEmail(email)).forEach(({ email, first, last }) => {
      vm.tempUsers.push({ email: email.trim().toLowerCase(), first, last, selected: true });
    });

    vm.selectTempCount();
  };

  // Temp User Functions Start
  vm.selectTempCount = () => {
    vm.tempSelectedCount = vm.tempUsers.filter(({ selected }) => selected).length;
    vm.tempUsersError = !!vm.tempUsers.filter(({ error }) => error).length;
  };
  vm.selectTemp = checkbox => {
    vm.tempUsers.forEach(user => (user.selected = checkbox));
    vm.selectTempCount();
  };
  vm.submitTemp = formData => {
    let { email, first, last } = angular.copy(formData);
    const selected = true;

    vm.errors.email = !email;
    vm.errors.first = !first;
    vm.errors.last = !last;

    if (vm.errors.email || vm.errors.first || vm.errors.last) return;

    email = email.toLowerCase();

    if (vm.tempUsers.map(({ email }) => email).includes(email))
      return Swal.alert('Hold up!', `${email} has already been added to the list`, 'error');

    vm.tempUsers.push({ email, first, last, selected });

    store.set('tempUsers', vm.tempUsers);

    vm.selectTempCount();
    vm.formData = {};
    vm.errors = {};
  };
  vm.removeTemp = (index, user) => {
    if (!index && user && user.email) index = findIndex(vm.tempUsers, ['email', user.email]);
    if (get(user, 'status.error', false) || get(user, 'status.message', '') === 'Existing User') {
      vm.tempUsers[index].error = true;
    } else {
      if (index) vm.tempUsers.splice(index, 1);
      if (index === 0) vm.tempUsers.pop();
    }
    vm.selectTempCount();
    store.set('tempUsers', vm.tempUsers);
  };

  vm.inviteTemp = index => {
    if (suppressEmailCheck()) return $q.reject('company emails are suppressed');

    const user = vm.tempUsers[index];
    user.firm_invite = true;

    vm.createBtn = true;

    submit([user], false, true)
      .then(() => {
        if (index) vm.tempUsers.splice(index, 1);
        if (index === 0) vm.tempUsers.pop();
        vm.selectTempCount();
        store.set('tempUsers', vm.tempUsers);
        vm.createBtn = false;
        $state.reload();
        Swal.toast('User invite sent!');
      })
      .catch(error => {
        $log.error(error);
        vm.createBtn = false;
        throw error;
      });
  };

  vm.createUsers = () => {
    if (!vm.tempUsers.length || !vm.selectTempCount) return;

    vm.createBtn = true;

    const users = vm.tempUsers.filter(({ selected }) => selected);
    submit(users, false, true)
      .then(() => {
        vm.createBtn = false;
        $state.reload();
      })
      .catch(error => {
        $log.error(error);
        vm.createBtn = false;
        throw error;
      });
  };

  function suppressEmailCheck() {
    const suppressEmails = preferences && !preferences.email;

    if (suppressEmails)
      Swal.alert(`Your company's email notifications are turned off. Please activate, and try again.`);

    return suppressEmails;
  }

  // Temp User Functions End

  function deactivateAccount(user, email, emailChange) {
    const { profile_uid } = user;
    return ApiClass.usersIdDelete({ id: profile_uid }, { email }, { queryParams: { manage: true } })
      .then(response => {
        if (emailChange) return Swal.toast('User account migrate!');

        Swal.toast('User Account Deactivated');
        user.archived = true;
        user.status = 'Inactive';
        user.status_color = 'label-danger';
        $state.reload();
        return user;
      })
      .catch(error => {
        $log.error(error);
        if (
          error &&
          error.data &&
          error.data.description === 'Existing Registered Email: User account already exists.'
        ) {
          Swal.alert(
            'Hold up!',
            `User information could not be copied because an account already exists for ${email}.`,
            'error',
            20000
          );
        }
        throw error;
      });
  }

  vm.changePassword = function(user) {
    const validator = value => {
      // Swal form validation
      if (!value) return 'Invalid password.';
      return;
    };

    return Swal.input('Enter new password', '', 'Enter password', 'password', validator)
      .then(({ value: password }) => {
        if (!password) return $q.resolve(user);
        return ApiClass.usersIdTypePatch(
          { id: user.profile_uid, type: 'password', manage: true },
          { password },
          { queryParams: { manage: true } }
        ).then(result => {
          if (result.data && result.data.item === 'success') return Swal.toast('User password updated!');
          $log.error(result);
          throw new Error('Admin password change error');
        });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.changeEmail = function(user) {
    const validator = value => {
      // Swal form validation
      if (value === user.email) return 'Email cannot match user account.';
      if (!HelperClass.validateEmail(value)) return 'Invalid email address.';
      return;
    };

    return Swal.input('Enter updated email', '', 'Enter email address', 'text', validator).then(({ value: email }) => {
      if (!email) return $q.resolve(user);
      if (email === user.email) return Swal.alert('Hold up!', 'Email cannot match user account.', 'error');
      return ApiClass.usersIdTypePatch(
        { id: user.profile_uid, type: 'email', manage: true },
        { email },
        { queryParams: { manage: true } }
      )
        .then(result => {
          if (result.data && result.data.item) {
            if (user.email === UserClass.email) AuthClass.setToken(result.data.item);
            $state.reload();
            return Swal.toast('User email updated!');
          }
          $log.error(result);
        })
        .catch(error => {
          if (
            error &&
            error.data &&
            error.data.description === 'Existing Registered Email: User account already exists.'
          ) {
            Swal.alert(
              'Hold up!',
              `User email was not updated because an account already exists for ${email}.`,
              'error',
              20000
            );
          }
          throw error;
        });
    });
  };

  vm.copyAccountToEmail = function(user, emailChange) {
    const validator = value => {
      // Swal form validation
      if (value === user.email) return 'Email cannot match user account.';
      if (!HelperClass.validateEmail(value)) return 'Invalid email address.';
      return;
    };

    return Swal.input('Input email address', '', 'Enter email address', 'text', validator)
      .then(({ value: email }) => {
        if (!email) return $q.resolve(user);
        if (email === user.email) return Swal.alert('Hold up!', 'Email cannot match user account.', 'error');
        return deactivateAccount(user, email, emailChange);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.deactivateAccount = user => {
    return Swal.checkBox(
      'Deactivate user account',
      "This action will lock the account and all historical data will be unchanged.  You may re-activate this user at a later date or you may copy the user's information to a new email address so they may still access their historical records.",
      'Submit',
      'Migrate user to a new account'
    )
      .then(({ value: emailBool }) => {
        if (emailBool === undefined) return $q.resolve(user);
        if (!emailBool) return deactivateAccount(user, false);

        return vm.copyAccountToEmail(user);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activateAccount(user) {
    const { profile_uid } = user;
    return ApiClass.usersIdPatch({ id: profile_uid }, { activate: true }, { queryParams: { manage: true } })
      .then(() => {
        Swal.toast('User account activated!');
        user.archived = false;
        user.status = 'Uninvited';
        user.status_color = 'label-warning';

        if (user.invited) {
          user.status = 'Pending';
          user.status_color = 'label-success';
        }

        if (user.firstLogin === false) {
          user.status = 'Active';
          user.status_color = 'label-primary';
        }
        $state.reload();
        return user;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  vm.activateAccount = user => {
    return Swal.confirm(
      'Reactivate user account?',
      "This will unlock the user's profile and allow them to login normally and access your Prolaera account."
    )
      .then(() => activateAccount(user, false))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.removeFirmInvite = user => {
    const { profile_uid, company_id } = user;
    Swal.confirm('Revoke invitation?', 'This will cancel the invitation for the user to join your Prolaera account.')
      .then(() => {
        return ApiClass.usersIdTypeTypeIdDelete(
          {
            id: profile_uid,
            type: 'invites',
            type_id: company_id
          },
          {},
          { queryParams: { manage: true } }
        ).then(() => {
          Swal.toast('User invitation revoked!');
          return $q.resolve($state.reload());
        });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  // Invite / Current User Functions Start
  vm.inviteUser = users => {
    if (suppressEmailCheck()) return $q.reject('company emails are suppressed');

    users = users.filter(({ selected }) => selected);
    return submit(users, true, false)
      .then(() => $state.reload())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  // Invite / Current User Functions End

  function submit(users, invite, temp) {
    return ApiClass.usersPut({}, { users, invite, baseUrl }, { queryParams: { manage: true } })
      .then(response => {
        const {
          data: { items }
        } = response;
        const createdUsers = items.filter(profile => {
          if (temp) return vm.removeTemp(false, profile);
          return true;
        });
        return { createdUsers };
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function activate() {
    $log.debug('Admin Users Settings Controller Activated');
    usersDict = {};
    vm.formData = {};
    vm.errors = {};
    vm.tempSelectedCount = 0;
    vm.tempUsers = store.get('tempUsers', vm.tempUsers) || [];
    vm.selectTempCount();
    vm.csvColumns = ['email', 'first', 'last'];
    vm.csvExampleData = [['john@prolaera.com', 'John', 'Doe'], ['jane@prolaera.com', 'Jane', 'Doe']];
    users.length = 0;
    uninvitedUsers.length = 0;

    $q.all([
      ApiClass.companiesIdGet({ manage: true, id: company_id }),
      ApiClass.scan(
        ApiClass.usersGet,
        {},
        {},
        {
          queryParams: {
            manage: true,
            'scan:limit': 2000,
            'include:archived': true,
            'include:firm_invites': true
          }
        }
      )
    ])
      .then(([{ data: { company } }, { items }]) => {
        if ('sso' in company && 'active' in company.sso) vm.ssoDisable = company.sso.active;

        items.forEach(user => {
          if (user.type === 'accountInvite') {
            user.firm_invite = true;
            if (user.status === 'Accepted') return;
            if (user.status === 'Invited') user.status_color = 'label-basic';
            if (user.status === 'Rejected') user.status_color = 'label-warning';
            if (!usersDict[user.profile_uid] || !usersDict[user.profile_uid].user) usersDict[user.profile_uid] = user;
            return;
          }

          user.status = 'Uninvited';
          user.status_color = 'label-warning';

          if (user.invited) {
            user.status = 'Pending';
            user.status_color = 'label-success';
          }

          if (user.firstLogin === false) {
            user.status = 'Active';
            user.status_color = 'label-primary';
          }

          if (user.archived) {
            user.status = 'Inactive';
            user.status_color = 'label-danger';
          }

          if (!user.invited && user.firstLogin !== false) {
            return uninvitedUsers.push(user);
          }

          usersDict[user.profile_uid] = user;
        });

        users = [...Object.values(usersDict)];

        vm.users = orderBy(users, ['status', 'email'], ['desc', 'asc']);
        vm.uninvitedUsers = orderBy(uninvitedUsers, ['status', 'email'], ['desc', 'asc']);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/users/index.js